import React from 'react'
// components
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AccordionOrigin from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import IntegrationCard, {
  IntegrationsProps
} from 'components/FormElements/ReduxForm/Forms/BusinessEntitiesForm/components/IntegrationsSection/components/IntegrationCard'
// constants
import { PANEL_STYLES } from '../UserData'
// themes
import { colors } from 'themes/index'
// hooks
import { useHasConnectedIntegrations } from 'components/FormElements/ReduxForm/Forms/BusinessEntitiesForm/components/IntegrationsSection/hooks/useHasConnectedIntegrations'

const Integrations: React.FC<IntegrationsProps> = ({ integrations }) => {
  const hasConnectedIntegrations = useHasConnectedIntegrations()

  if (!hasConnectedIntegrations) {
    return null
  }

  return (
    <AccordionOrigin>
      <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor={colors.blue500} />}>Integrations</AccordionSummary>
      <AccordionDetails style={PANEL_STYLES}>
        <IntegrationCard integrations={integrations} />
      </AccordionDetails>
    </AccordionOrigin>
  )
}

export default Integrations
